import type { JerseyOutputMode } from '@klothiq/domain';

export default function JerseyGenerationMode({
  label,
  value,
  onChange,
  autoDisabled = false,
}: {
  label: string;
  value: JerseyOutputMode;
  onChange: (value: JerseyOutputMode) => void;
  autoDisabled?: boolean;
}) {
  return (
    <div
      role="group"
      aria-label={`${label} entry mode`}
      className="inline-flex max-w-full rounded-xl border border-border bg-muted/30 p-1"
    >
      {(['manual', 'auto'] as const).map((mode) => (
        <button
          key={mode}
          type="button"
          aria-pressed={value === mode}
          disabled={mode === 'auto' && autoDisabled}
          onClick={() => onChange(mode)}
          className={`min-h-11 rounded-lg px-3 text-sm font-medium transition-colors disabled:opacity-50 ${value === mode ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-accent'}`}
        >
          {mode === 'auto' ? 'Auto' : 'Manual'}
        </button>
      ))}
    </div>
  );
}
